import { createContext } from 'react';

type RadioGroupContextValue = {
  name: string;
  selectedValue?: string | number;
  onChange?: (...event: Array<React.SyntheticEvent<HTMLInputElement>>) => void;
};

/**
 * {@link RadioGroupContext} provides shared values to radio buttons within a {@link RadioGroup}.
 */
export const RadioGroupContext = createContext<RadioGroupContextValue | undefined>(undefined);
